export default "__VITE_ASSET__CKuJ1ASa__"